// Google Tag Manager (контейнер GTM-NWSD5KBZ, тот же, что на лендинге). Внутри контейнера —
// GA4: просмотры (включая SPA-переходы через историю браузера), user_id и цели из dataLayer.
//
// Стандартный сниппет GTM, только подключается из кода: так он, как и Метрика, не работает
// в dev (vite dev, import.meta.env.PROD=false) и не стартует, пока в адресе секретный ?token=
// (см. AnalyticsTracker). <noscript>-часть не нужна: без JS приложение не работает.

export const GTM_ID = 'GTM-NWSD5KBZ';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

let started = false;

/** Однократная загрузка контейнера (только в production-сборке). */
export function initGtm(): void {
  if (!import.meta.env.PROD || started) return;
  started = true;
  gtmPush({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
}

/** Сообщение в dataLayer; до загрузки gtm.js копится в массиве и обрабатывается по порядку. */
export function gtmPush(data: Record<string, unknown>): void {
  if (!import.meta.env.PROD) return;
  (window.dataLayer = window.dataLayer || []).push(data);
}
